/** Texts of the pages: lists, detail page, checklist, proof and sources. */
export const pages = {
  fields: {
    title: 'Titel',
    buyer: 'Vergabestelle',
    place: 'Ort',
    state: 'Bundesland',
    nuts: 'Region (NUTS)',
    deadline: 'Angebotsfrist',
    participationDeadline: 'Teilnahmefrist',
    questionsDeadline: 'Frist für Fragen',
    cpv: 'CPV-Codes',
    nature: 'Art',
    procedure: 'Verfahren',
    regulation: 'Vergaberecht',
    estimatedValue: 'Geschätzter Wert',
    published: 'Veröffentlicht',
    noticeId: 'Bekanntmachung',
    source: 'Quelle',
    status: 'Status',
    owner: 'Verantwortlich',
    markedAt: 'Markiert am',
    submittedAt: 'Eingereicht am',
    documentsUrl: 'Link zu den Vergabeunterlagen',
    description: 'Beschreibung',
  },
  regions: {
    BW: 'Baden-Württemberg',
    BY: 'Bayern',
    BE: 'Berlin',
    BB: 'Brandenburg',
    HB: 'Bremen',
    HH: 'Hamburg',
    HE: 'Hessen',
    MV: 'Mecklenburg-Vorpommern',
    NI: 'Niedersachsen',
    NW: 'Nordrhein-Westfalen',
    RP: 'Rheinland-Pfalz',
    SL: 'Saarland',
    SN: 'Sachsen',
    ST: 'Sachsen-Anhalt',
    SH: 'Schleswig-Holstein',
    TH: 'Thüringen',
  },
  natures: { works: 'Bauleistung', services: 'Dienstleistung', supplies: 'Lieferung' },
  regulations: { eu: 'EU-weit', national: 'National' },
  sourceNames: {
    oev: 'oeffentlichevergabe.de',
    nrw: 'Vergabemarktplätze NRW',
    ted: 'TED (EU-Amtsblatt)',
    berlin: 'Vergabeplattform Berlin',
    vkberlin: 'Vergabekooperation Berlin',
    rib: 'RIB meinauftrag',
    bund: 'service.bund.de',
    manual: 'Von Hand erfasst',
  },
  deadlines: {
    none: 'Keine Frist',
    passed: 'Abgelaufen',
    today: 'Endet heute',
    daysLeft_one: 'Noch {{count}} Tag',
    daysLeft_other: 'Noch {{count}} Tage',
    participationShort: 'Teilnahme:',
  },
  failures: {
    versionConflict: 'Inzwischen hat jemand anderes etwas geändert.',
    notMarked: 'Die Ausschreibung ist nicht in Bearbeitung.',
    notInReview: 'Das geht nur, solange die Ausschreibung in Prüfung ist.',
    manualTender: 'Das geht bei einer von Hand erfassten Ausschreibung nicht.',
    notSubmitted: 'Die Ausschreibung ist noch nicht eingereicht.',
    tooManyMembers: 'Es sind schon so viele Personen beteiligt, wie möglich.',
    tooManyItems: 'Die Checkliste hat schon so viele Punkte, wie möglich.',
    tooManyLinks: 'An diesem Punkt hängen schon so viele Nachweise, wie möglich.',
    aiDisabled: 'Die KI ist für diese Funktion ausgeschaltet.',
    aiBudget: 'Das KI-Budget der Firma ist für diesen Monat aufgebraucht.',
    aiBusy: 'Die KI ist gerade ausgelastet. Bitte gleich noch einmal versuchen.',
    aiFailed: 'Die KI hat keine brauchbare Antwort geliefert. Bitte noch einmal versuchen.',
    aiUnavailable: 'Die KI ist gerade nicht erreichbar.',
    invalidInput: 'Bitte die Eingaben prüfen.',
    noDocuments: 'Im Ordner liegen noch keine Unterlagen. Lade sie zuerst hoch.',
    aiFilesTooLarge:
      'Die Unterlagen sind für die KI zu umfangreich. Entferne Dateien, die für die Zusammenfassung nicht nötig sind.',
    documentsNoLink: 'Die Ausschreibung hat keinen Link zu den Unterlagen.',
    documentsHost:
      'Von diesem Portal lädt die STAW App nichts selbst. Lade die Unterlagen dort herunter und hier hoch.',
    documentsNotDirect:
      'Das Portal gibt die Unterlagen nur nach Anmeldung oder über ein Formular heraus. Lade sie dort herunter und hier hoch.',
    documentsTooLarge: 'Die Unterlagen sind größer als 100 MB.',
    documentsUnavailable: 'Das Portal antwortet gerade nicht. Bitte später noch einmal versuchen.',
    sharepointDenied: 'SharePoint lehnt den Zugriff ab. Die Verwaltung muss die Anbindung prüfen.',
    sharepointUnavailable: 'SharePoint ist gerade nicht erreichbar.',
    sharepointDisabled: 'Die Anbindung an SharePoint ist ausgeschaltet.',
    notFound: 'Das gibt es nicht mehr.',
    forbidden: 'Dafür fehlt dir die Berechtigung.',
    conflict: 'Das passt nicht zum aktuellen Stand. Bitte die Seite neu laden.',
    rateLimited: 'Zu viele Anfragen. Bitte kurz warten.',
  },
  cpv: {
    add: 'CPV-Code hinzufügen',
    search: 'Code oder Begriff suchen',
    empty: 'Kein passender Code',
    remove: '{{name}} entfernen',
  },
  list: {
    title: 'Ausschreibungen',
    description: 'Öffentliche Ausschreibungen aus Deutschland, deren Frist noch läuft.',
    count_one: '{{count}} Ausschreibung',
    count_other: '{{count}} Ausschreibungen',
    search: 'Ausschreibungen durchsuchen',
    searchPlaceholder: 'Titel, Vergabestelle, Ort',
    statusAll: 'Alle',
    statusStock: 'Nicht markiert',
    statusWork: 'In Bearbeitung',
    moreCodes_one: '(+{{count}} weiterer)',
    moreCodes_other: '(+{{count}} weitere)',
    mark: '„{{title}}“ markieren',
    marked: 'Markiert. Du findest die Ausschreibung unter „Meine Ausschreibungen“.',
    addState: 'Bundesland',
    searchState: 'Bundesland suchen',
    removeState: '{{name}} entfernen',
    within: 'Frist endet in',
    withinDays_one: 'Frist in {{count}} Tag',
    withinDays_other: 'Frist in {{count}} Tagen',
    withinAny: 'Frist beliebig',
    minDays: 'Mindestens noch',
    minDaysValue_one: 'Mindestens {{count}} Tag',
    minDaysValue_other: 'Mindestens {{count}} Tage',
    minDaysAny: 'Restzeit beliebig',
    natureAll: 'Jede Art',
    regulationAll: 'EU und national',
    sourceAll: 'Alle Quellen',
    published: 'Veröffentlicht',
    publishedDays_one: 'Seit gestern',
    publishedDays_other: 'In den letzten {{count}} Tagen',
    publishedAny: 'Jederzeit veröffentlicht',
    sort: 'Sortierung',
    sorts: {
      deadline: 'Frist zuerst',
      published: 'Neueste zuerst',
      relevance: 'Beste Treffer',
    },
    range: '{{from}}–{{to}} von {{total}}',
    noMatches: 'Keine passende Ausschreibung',
    noMatchesHint: 'Andere Suchbegriffe oder weniger Filter versuchen.',
    empty: 'Noch keine Ausschreibungen',
    emptyHint:
      'Der Import läuft jeden Morgen. Eine Ausschreibung, die dir direkt zugeschickt wurde, kannst du von Hand erfassen.',
  },
  mine: {
    title: 'Meine Ausschreibungen',
    description:
      'Markierte und von Hand erfasste Ausschreibungen, von der Prüfung bis zur Rückmeldung.',
    empty: 'Noch nichts in Bearbeitung',
    emptyHint: 'Markiere in der Übersicht eine Ausschreibung, dann erscheint sie hier.',
  },
  manual: {
    create: 'Von Hand erfassen',
    createTitle: 'Ausschreibung erfassen',
    editTitle: 'Ausschreibung ändern',
    hint: 'Zum Beispiel eine Angebotsanfrage, die direkt bei euch ankam. Sie ist sofort in Bearbeitung, mit dir als verantwortlicher Person.',
    created: 'Ausschreibung erfasst.',
    updated: 'Änderungen gespeichert.',
    conflictHint: 'Bitte den Dialog schließen und die Seite neu laden.',
    noState: 'Kein Bundesland',
    importedHint:
      'Was du hier änderst, behält die App, auch wenn die Quelle die Bekanntmachung später ändert. Alles andere folgt weiter der Quelle.',
  },
  detail: {
    notFound: 'Ausschreibung nicht gefunden',
    notFoundHint: 'Sie wurde gelöscht, oder die Frist ist abgelaufen und sie war nicht markiert.',
    mark: 'Markieren',
    markedToast: 'Markiert. Die Ausschreibung ist jetzt in Prüfung.',
    unmark: 'Markierung zurücknehmen',
    unmarkedToast: 'Markierung zurückgenommen.',
    unmarkTitle: 'Markierung zurücknehmen?',
    unmarkDescription:
      'Beteiligte Personen, Zusammenfassung, Dateien und Kommentare werden entfernt. Die Ausschreibung bleibt in der Übersicht, solange ihre Frist läuft.',
    deleted: 'Ausschreibung gelöscht.',
    deleteTitle: 'Ausschreibung löschen?',
    deleteDescription:
      'Die Ausschreibung verschwindet mit Dateien und Kommentaren. Eine importierte Ausschreibung kommt auch mit dem nächsten Import nicht wieder.',
    stockTitle: 'Noch nicht markiert',
    stockHint:
      'Markiere die Ausschreibung, um sie zu prüfen, eine Checkliste anzulegen und an die Frist erinnert zu werden.',
    stockHintReadOnly: 'Diese Ausschreibung bearbeitet noch niemand.',
    closedTitle: 'Nicht mehr in der Quelle',
    closedHint:
      'Die Quelle führt diese Ausschreibung nicht mehr, sie wurde zurückgezogen oder ist abgeschlossen.',
    notice: 'Bekanntmachung',
    edited: 'Von Hand geändert: {{fields}}. Der Import überschreibt diese Angaben nicht.',
    editedFields: {
      title: 'Titel',
      description: 'Beschreibung',
      buyerName: 'Vergabestelle',
      placeCity: 'Ort',
      state: 'Bundesland',
      deadline: 'Angebotsfrist',
      participationDeadline: 'Teilnahmefrist',
      documentsUrl: 'Link zu den Unterlagen',
      cpv: 'CPV-Codes',
    },
    links: 'Links',
    documents: 'Vergabeunterlagen öffnen',
    linksHint: 'Die Links führen auf die Seiten der Vergabestelle oder der Quelle.',
    requirements: 'Eignungskriterien',
    requirementsHint: 'Aus der Bekanntmachung, wie dort angegeben.',
    lots_one: '{{count}} Los',
    lots_other: '{{count}} Lose',
    lot: 'Los {{id}}',
    lotDeadline: 'Frist {{date}}',
  },
  people: {
    title: 'Personen',
    noOwner: 'Niemand verantwortlich',
    chooseOwner: 'Verantwortliche Person wählen',
    ownerChanged: 'Verantwortliche Person geändert.',
    members: 'Beteiligt',
    noMembers: 'Noch niemand beteiligt.',
    add: 'Person beteiligen',
    added: 'Person beteiligt.',
    remove: 'Entfernen',
    removed: 'Person entfernt.',
    removeTitle: 'Person entfernen?',
    removeDescription: 'Die Person bekommt keine Erinnerungen zu dieser Ausschreibung mehr.',
    feedback: 'Rückmeldung der Vergabestelle',
    feedbackDue: 'Prüfen fällig seit {{date}}',
    feedbackNext: 'Nächste Prüfung am {{date}}',
    feedbackNone: 'Keine Prüfung geplant',
    feedbackChecked: 'Rückmeldung geprüft',
    feedbackConfirmed: 'Gespeichert. Nächste Prüfung am {{date}}.',
    feedbackConfirmedPlain: 'Gespeichert.',
    feedbackHint:
      'Kommt die Zu- oder Absage, den Status auf „Gewonnen“ oder „Nicht erhalten“ setzen. Dann enden die Erinnerungen.',
  },
  project: {
    title: 'Projekt',
    hint: 'Nach dem Zuschlag ein Projekt anlegen. Es ist dann mit der Ausschreibung verknüpft.',
    create: 'Projekt anlegen',
    linked: 'Projekt verknüpft.',
    clientTitle: 'Wer ist der Auftraggeber?',
    clientHint: 'Die Vergabestelle ist „{{name}}“. Wähle den Kunden aus oder lege ihn an.',
    clientHintNoBuyer: 'Wähle den Kunden aus oder lege ihn an.',
    client: 'Kunde',
    suggested: 'Passt zum Namen der Vergabestelle.',
    notFound: 'Unter diesem Namen gibt es noch keinen Kunden.',
    next: 'Weiter',
  },
  summary: {
    title: 'KI-Zusammenfassung',
    hint: 'Ein Vorschlag der KI. Prüfe ihn gegen die Vergabeunterlagen.',
    create: 'Zusammenfassen',
    again: 'Neu zusammenfassen',
    created: 'Zusammenfassung erstellt.',
    empty: 'Noch keine Zusammenfassung',
    emptyHint:
      'Die KI fasst die Bekanntmachung zusammen und schlägt Unterlagen für die Checkliste vor.',
    basisNotice: 'Aus der Bekanntmachung',
    basisFiles: 'Aus Bekanntmachung und Unterlagen',
    createFiles: 'Mit Unterlagen zusammenfassen',
    unread:
      'Diese Dateien hat die KI nicht gelesen, weil sie gescannt, in einem anderen Format oder für einen Aufruf zu umfangreich sind:',
    documents: 'Vorgeschlagene Unterlagen',
    inChecklist: 'In der Checkliste',
    take_one: '{{count}} Punkt in Checkliste übernehmen',
    take_other: '{{count}} Punkte in Checkliste übernehmen',
    taken: 'In die Checkliste übernommen.',
  },
  documents: {
    title: 'Unterlagen',
    hint: 'Vergabeunterlagen und eigene Dokumente. Mit SharePoint liegen sie im Ordner der Ausschreibung.',
    fetch: 'Unterlagen vom Portal laden',
    fetched: 'Unterlagen geladen.',
    folder: 'Ordner in SharePoint anlegen',
  },
  checklist: {
    title: 'Checkliste',
    hint: 'Was für die Abgabe fehlt, mit Nachweisen und Dateien.',
    progress: '{{done}} von {{count}} erledigt',
    zip: 'Alles als ZIP',
    zipName: 'Abgabe',
    empty: 'Die Checkliste ist leer',
    emptyHint: 'Lege Punkte an oder übernimm die Vorschläge der KI-Zusammenfassung.',
    emptyReadOnly: 'Es gibt keine Punkte.',
    doneLabel: '„{{title}}“ erledigt',
    fromAi: 'KI-Vorschlag',
    proofLinked: 'Nachweis verknüpft',
    proofUnavailable: 'Nachweis nicht verfügbar',
    unlink: '{{name}} lösen',
    actionsFor: 'Aktionen für „{{title}}“',
    link: 'Nachweis verknüpfen',
    files_one: '{{count}} Datei',
    files_other: '{{count}} Dateien',
    newItem: 'Neuer Punkt',
    newItemPlaceholder: 'Zum Beispiel Haftpflichtversicherung',
    removed: 'Punkt gelöscht.',
    removeTitle: 'Punkt löschen?',
    removeDescription:
      '„{{title}}“ wird mit seinen Dateien gelöscht. Verknüpfte Nachweise bleiben erhalten.',
    editTitle: 'Punkt ändern',
    itemTitle: 'Titel',
    linkTitle: 'Nachweis verknüpfen',
    linkHint: 'Für „{{title}}“.',
    proof: 'Nachweis',
    chooseProof: 'Nachweis wählen',
    searchProof: 'Nachweis suchen',
    noProof: 'Kein passender Nachweis',
    linked: 'Nachweis verknüpft.',
  },
  proof: {
    listTitle: 'Nachweise',
    listDescription:
      'Zertifikate, Versicherungen, Referenzen und Erklärungen, die ihr für Angebote bereithaltet.',
    create: 'Neuer Nachweis',
    createTitle: 'Nachweis anlegen',
    createHint: 'Das Dokument selbst kommt danach als Datei dazu oder steht hinter dem Link.',
    editTitle: 'Nachweis ändern',
    created: 'Nachweis angelegt.',
    updated: 'Änderungen gespeichert.',
    deleted: 'Nachweis gelöscht.',
    conflictHint: 'Bitte den Dialog schließen und die Seite neu laden.',
    titlePlaceholder: 'Zum Beispiel Betriebshaftpflicht',
    category: 'Kategorie',
    categoryAll: 'Alle Kategorien',
    chooseCategory: 'Kategorie wählen',
    searchCategory: 'Kategorie suchen oder neu eingeben',
    noCategory: 'Noch keine Kategorie',
    newCategory: '„{{name}}“ als Kategorie',
    issuedOn: 'Ausgestellt am',
    validUntil: 'Gültig bis',
    validBeforeIssued: 'Das Ende der Gültigkeit liegt vor dem Ausstellungsdatum.',
    responsible: 'Zuständig',
    link: 'Link',
    linkHint: 'Zum Beispiel der Ordner in SharePoint, in dem das Dokument liegt.',
    openLink: 'Link öffnen',
    usage: 'Verwendet',
    usageCount_one: 'In {{count}} Checkliste',
    usageCount_other: 'In {{count}} Checklisten',
    details: 'Angaben',
    changed: 'Zuletzt geändert',
    search: 'Nachweise durchsuchen',
    searchPlaceholder: 'Titel, Kategorie, Beschreibung',
    validityFilter: 'Gültigkeit',
    validityAll: 'Jede Gültigkeit',
    validityFilters: {
      valid: 'Gültig',
      expiring: 'Läuft bald ab',
      expired: 'Abgelaufen',
    },
    validity: {
      valid: 'Gültig bis {{date}}',
      expiring: 'Läuft am {{date}} ab',
      expired: 'Abgelaufen am {{date}}',
    },
    validUntilShort: 'bis {{date}}',
    noExpiry: 'Unbefristet',
    noMatches: 'Kein passender Nachweis',
    noMatchesHint: 'Andere Suchbegriffe oder weniger Filter versuchen.',
    empty: 'Noch keine Nachweise',
    emptyHint:
      'Lege Nachweise einmal an und verknüpfe sie mit den Checklisten. Die App erinnert, bevor einer abläuft.',
    notFound: 'Nachweis nicht gefunden',
    notFoundHint: 'Er wurde gelöscht oder ist für dich nicht sichtbar.',
    expiredTitle: 'Abgelaufen',
    expiredHint: 'Lade einen neuen Nachweis hoch und trage das neue Ablaufdatum ein.',
    expiringTitle: 'Läuft bald ab',
    expiringHint: 'Kümmere dich rechtzeitig um einen neuen Nachweis.',
    deleteTitle: 'Nachweis löschen?',
    deleteDescription: 'Der Nachweis wird mit seinen Dateien gelöscht.',
    deleteDescriptionUsed_one:
      'Der Nachweis wird mit seinen Dateien gelöscht und aus {{count}} Checkliste gelöst.',
    deleteDescriptionUsed_other:
      'Der Nachweis wird mit seinen Dateien gelöscht und aus {{count}} Checklisten gelöst.',
  },
  sourcesPage: {
    title: 'Quellen',
    description: 'Woher die Ausschreibungen kommen und wann sie zuletzt abgerufen wurden.',
    settings: 'Quellen ein- und ausschalten',
    run: 'Alle abrufen',
    runOne: 'Jetzt abrufen',
    runOneLabel: 'Jetzt abrufen: {{name}}',
    started: 'Abruf gestartet. Neue Ausschreibungen erscheinen in einigen Minuten.',
    scheduleTitle: 'Täglicher Abruf',
    scheduleHint:
      'Die App ruft jeden Morgen alle eingeschalteten Quellen ab. Ausschreibungen ohne Markierung verschwinden, sobald ihre Frist abgelaufen ist.',
    off: 'Ausgeschaltet',
    failed: 'Fehler',
    ok: 'Läuft',
    never: 'Noch nicht abgerufen',
    lastRun: 'Letzter Abruf',
    lastDay: 'Abgerufen bis',
    lastCount: 'Neue oder geänderte zuletzt',
    errorTitle: 'Der letzte Abruf ist fehlgeschlagen',
    about: {
      oev: 'Bekanntmachungen von Bund, Ländern und Kommunen aus dem Datenservice Öffentlicher Einkauf.',
      nrw: 'Offene Daten der Vergabemarktplätze in Nordrhein-Westfalen und des Bau- und Liegenschaftsbetriebs NRW, auch nationale Vergaben.',
      ted: 'EU-weite Bekanntmachungen aus dem Amtsblatt der EU mit Auftraggeber oder Ausführungsort in Deutschland, mit CPV-Codes.',
      vkberlin:
        'Ausschreibungen von BVG, Berliner Wasserbetrieben, BSR, Messe Berlin, Forschungsverbund Berlin und weiteren, auch nichtförmliche Verfahren, ohne CPV-Codes.',
      berlin:
        'Die 50 neuesten Bekanntmachungen der Vergabeplattform des Landes Berlin, ohne CPV-Codes.',
      bund: 'Neueste Ausschreibungen aus dem Portal des Bundes, ohne CPV-Codes.',
    },
    licence: {
      oev: 'Daten: Datenservice Öffentlicher Einkauf, oeffentlichevergabe.de.',
      nrw: 'Daten: Vergabemarktplätze NRW und BLB NRW über open.nrw und GovData, Lizenz dl-de/zero-2.0.',
      ted: 'Daten: Amt für Veröffentlichungen der EU, ted.europa.eu, frei nachnutzbar (Beschluss 2011/833/EU).',
      berlin: 'Daten: Vergabeplattform des Landes Berlin, berlin.de.',
      vkberlin:
        'Daten: Vergabekooperation Berlin, Administration Intelligence AG, vergabekooperation.berlin.',
      bund: 'Daten: service.bund.de.',
    },
  },
};
